import axios from 'axios'
import authStore from '@/store/auth'
import router from '@/router'

const request = axios.create({
  baseURL: process.env.VUE_APP_APIPATH_A,
  timeout: 10000,
})

// 可以換發解決的 401
const REFRESHABLE_TITLES = ['TOKEN_EXPIRED', 'SESSION_REVOKED']
// 換發也解決不了、必須重新登入的 401
const LOGOUT_TITLES = ['TOKEN_MISSING', 'TOKEN_INVALID']

// 正在進行中的換發，用來讓同時失敗的請求共用同一次換發
let refreshPromise = null

// 請求攔截器：送出前帶上 token（設 skipAuth: true 的請求不帶，例如呼叫其他後端）
request.interceptors.request.use((config) => {
  const auth = authStore()

  if (auth.accessToken && !config.skipAuth) {
    config.headers.Authorization = `Bearer ${auth.accessToken}`
  }

  return config
})

// 回應攔截器：處理 401
request.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status
    const title = error.response?.data?.title
    const originalConfig = error.config

    // 不帶本後台 token 的請求（例如後端 B 1113），失敗直接交給頁面，不走換發與登出
    if (originalConfig?.skipAuth) {
      return Promise.reject(error)
    }

    // 不是 401，不處理
    if (status !== 401) {
      return Promise.reject(error)
    }

    // 換發也沒用，直接導回登入頁
    if (LOGOUT_TITLES.includes(title)) {
      redirectToLogin()
      return Promise.reject(error)
    }

    // 不是可換發的錯誤（例如帳密錯誤），或已經重試過，原樣交給頁面
    if (!REFRESHABLE_TITLES.includes(title) || originalConfig._retry) {
      return Promise.reject(error)
    }

    originalConfig._retry = true

    try {
      if (!refreshPromise) {
        const auth = authStore()
        refreshPromise = auth.refresh().finally(() => {
          refreshPromise = null
        })
      }
      await refreshPromise

      // 換發成功，用新 token 重送原本的請求
      return request(originalConfig)
    } catch (refreshError) {
      redirectToLogin()
      return Promise.reject(refreshError)
    }
  }
)

function redirectToLogin() {
  const auth = authStore()
  auth.clearTokens()

  if (router.currentRoute.value.path !== '/login') {
    router.push('/login')
  }
}

export default request